export default {
  reloadControllerConfig: 'Znovu načítať konfiguráciu kontroléra',
};
